import { render, staticRenderFns } from "./LenderBenefits.vue?vue&type=template&id=160e8534&scoped=true&"
import script from "./LenderBenefits.vue?vue&type=script&lang=js&"
export * from "./LenderBenefits.vue?vue&type=script&lang=js&"
import style0 from "./LenderBenefits.vue?vue&type=style&index=0&id=160e8534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e8534",
  null
  
)

export default component.exports